import flagIndia from "assets/images/flags/flagIndian.png";

const languages = {
  en: {
    label: "English",
    flag: flagIndia,
  },
  hi: {
    label: "Hindi",
    flag: flagIndia,
  },
  gu: {
    label: "Gujarati",
    flag: flagIndia,
  },
};

export default languages;
